import React, { useState, useEffect } from 'react';
import { FieldDataStrings as Strings } from '../../utils/config'
import { getFieldTypeString } from '../../utils/helpers'
import Spinner from '../common/Spinner'
import * as fieldTypeApi from '../../api/fieldTypeApi'
import FieldDataTextBox from './FieldDataTypes/FieldDataTextBox';
import FieldDataHtmlEditor from './FieldDataTypes/FieldDataHtmlEditor';
import FieldDataPageSelector from './FieldDataTypes/FieldDataPageSelector';
import FieldDataCheckbox from './FieldDataTypes/FieldDataCheckbox';
import FieldDataAssetManager from './FieldDataTypes/FieldDataAssetManager';
import FieldDataDropDown from './FieldDataTypes/FieldDataDropDown';
import FieldDataList from './FieldDataTypes/FieldDataList';
import FieldDataDateTime from './FieldDataTypes/FieldDataDateTime';
import './styles.css'

const FieldDataModel = ({ modelKey, dataFields, initialDataModel, onFieldDataChange, isPopUp }) => {
    const [dataModelObject, setDataModelObject] = useState(initialDataModel);
    const [fieldTypes, setFieldTypes] = useState({});
    const noDataString = isPopUp ? Strings.noListPlaceholder : Strings.noTemplatesPlaceholder;

    useEffect(() => {
        const fetchFieldTypes = async () => {
            var types = await fieldTypeApi.getAllFieldTypes();
            var typeDict = types.reduce(function (map, type) {
                map[type.Id] = type.Name;
                return map;
            }, {})
            setFieldTypes(typeDict);
        }
        fetchFieldTypes();
    }, [])

    useEffect(() => {
        if (JSON.stringify(dataModelObject) !== JSON.stringify(initialDataModel) || isPopUp) {
            onFieldDataChange(modelKey, dataModelObject);
        }
    }, [dataModelObject]);

    const getDataFieldValue = (dataFieldName) => {
        if (typeof dataModelObject !== 'undefined'
            && typeof dataModelObject[dataFieldName] !== 'undefined') {
            return dataModelObject[dataFieldName];
        }

        return null;
    }

    const handleFieldDataTextChange = (fieldName, fieldData) => {
        setDataModelObject(prevDataModelObject => ({
            ...prevDataModelObject,
            [fieldName]: fieldData
        }));
    }

    const renderFieldData = (dataField, fieldType, i) => {
        var sharedProps = {
            fieldKey: i,
            handleFieldDataTextChange,
            fieldName: dataField.Name,
            friendlyName: dataField.FriendlyName,
            fieldValue: getDataFieldValue(dataField.Name)
        }
        switch (fieldType) {
            case 'HTML':
                return (
                    <FieldDataHtmlEditor modelKey={modelKey} {...sharedProps} isPopUp={isPopUp} />
                );
            case 'PageLink':
                return (
                    <FieldDataPageSelector {...sharedProps} />
                );
            case 'Checkbox':
                return (
                    <FieldDataCheckbox {...sharedProps} />
                );
            case 'Asset':
                return (
                    <FieldDataAssetManager {...sharedProps} />
                );
            case 'Dropdown':
                return (
                    <FieldDataDropDown options={dataField.Options} {...sharedProps} />
                );
            case 'List':
                return (
                    <FieldDataList children={dataField.Children} isPopUp={isPopUp} {...sharedProps} />
                );
            case 'Date':
                return (
                    <FieldDataDateTime {...sharedProps} showTimeInput={false} />
                );
            case 'DateTime':
                return (
                    <FieldDataDateTime {...sharedProps} showTimeInput={true} />
                );
            case 'Text':
            default:
                return (
                    <FieldDataTextBox {...sharedProps} />
                );
        }
    }

    const renderFieldDataModel = () => {
        return (
            dataFields.length > 0 ?
                dataFields.map((dataField, i) => {
                    var fieldType = fieldTypes[dataField.TypeId]

                    return (
                        <div className='td-field-data-display row'>
                            <div className='td-field-header col-12'>
                                {dataField.FriendlyName || dataField.Name}
                                <span className="td-field-type-name">({getFieldTypeString(fieldType)})</span>
                            </div>
                            {renderFieldData(dataField, fieldType, i)}
                        </div>
                    )
                })
                : <span>{noDataString}</span>
        )
    }

    return (
        <div className={isPopUp ? 'td-field-data-model-popup' : ''}>
            {
                fieldTypes.length <= 0 ?
                    <Spinner /> :
                    renderFieldDataModel()
            }
        </div>
    );

}

export default FieldDataModel;
